export default "__VITE_ASSET__Cv9S3LJv__"